export default __webpack_public_path__ + "static/media/kredit_tizim_nizomi.b3a7e0af.pdf";